// src/services/users.js
import api from './api';

export const usersAPI = {
  getProfile: () =>
    api.get('/users/profile'),

  getRecentActivity: () =>
    api.get('/users/recent_activity'),

  updateProfile: (data) =>
    api.put('/users/update_profile', { user: data }),

  // ✅ FIXED: was [api.post](http://api.post) — broken markdown link syntax
  uploadProfileImage: (file) => {
    const formData = new FormData();
    formData.append('profile_image', file);
    return api.post('/users/upload_profile_image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  updateSellerInfo: (data) =>
    api.put('/users/update_seller_info', { user: data }, {
      headers: { 'Content-Type': 'application/json' }
    }),

  // ✅ FIXED: same broken syntax here too
  uploadDocuments: (files) => {
    const formData = new FormData();
    files.forEach(file => formData.append('documents[]', file));
    return api.post('/users/upload_documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  getDocuments: () =>
    api.get('/users/documents'),

  removeDocument: (docId) =>
    api.delete(`/users/documents/${docId}`),

  verifyPhone: () =>
    api.put('/users/verify_phone'),

  verifyEmail: () =>
    api.put('/users/verify_email'),

  removeProfileImage: () =>
    api.delete('/users/remove_profile_image'),
};